<template>
    <k-panel>
        <k-panel-header slot="header">
            {{ $t("reservationDetails") }}
        </k-panel-header>
        <div>
            <k-panel-row>
                <div slot="left">{{ $t("reservedPrincipal") }}</div>
                <div slot="right">
                    <div class="text-right">
                        {{ reservation.principalReserved | currencyFormat(currencySymbol) }}
                    </div>
                    <div v-if="reservation.principalReserved" class="flex justify-end gap-2 mt-5">
                        <a-popconfirm
                            title="Approve reservation?"
                            ok-text="Yes"
                            cancel-text="No"
                            @confirm="approveReservation()"
                        >
                            <a-button type="primary" link>
                                {{ $t("approve") }}
                            </a-button>
                        </a-popconfirm>

                        <a-popconfirm
                            title="Cancel reservation?"
                            ok-text="Yes"
                            cancel-text="No"
                            @confirm="cancelReservation()"
                        >
                            <a-button type="danger" ghost link>
                                {{ $t("cancel") }}
                            </a-button>
                        </a-popconfirm>
                    </div>
                </div>
            </k-panel-row>
            <a-alert v-if="error" type="error" closable banner
                     :message="error" @close="error=null">
            </a-alert>
        </div>

    </k-panel>
</template>

<script>
export default {
    props: {
        trancheUuid: {
            type: String,
            required: true
        },
        reservation: {
            type: Object,
            required: true
        },
        currencySymbol: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            error: null,
        };
    },
    methods: {
        async cancelReservation() {
            await this.$post(`tranche/${this.trancheUuid}/cancel-reservation`);
            this.$message.success('Reservation cancelled');
            this.$emit('on-update');
        },
        async approveReservation() {
            try {
                this.error = null;
                await this.$post(`tranche/${this.trancheUuid}/settle-reservation`);
                this.$message.success('Reservation processed successfully');
                this.$emit('on-update');
            } catch (e) {
                if (e.response && e.response.status === 400) {
                    this.error = e.response.data.errors;
                }
            }
        },
    }
};
</script>


